export default __webpack_public_path__ + "static/media/aristotle.a162ddaf.png";